import { render, staticRenderFns } from "./CompanyCompanyAllocation.vue?vue&type=template&id=aba75c80"
import script from "./CompanyCompanyAllocation.vue?vue&type=script&lang=js"
export * from "./CompanyCompanyAllocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports